import axiosInstance from 'api/axiosInstance';
import type { TagItemType } from 'types/repository.types';

const getAllTags = (): Promise<TagItemType[]> =>
  axiosInstance.get(`/v2/repository-document-tags?perPage=1000000&page=1`);

export default getAllTags;
